import {
  CashRegisterStateEnum,
  IRegisterWithOwner,
  ShiftStateEnum,
} from "@prostocheck/shared";

import { IObjectsResponse, IRegistrarStateResponse } from "../commands";

/**
 * Flattens an `Objects` response into the register list. A ПРРО whose
 * registration was cancelled is reported as `closed` — it still holds history
 * worth reading, so it is never dropped from the list.
 *
 * `shiftState` is unknown at this point: `Objects` does not carry it, and one
 * `TransactionsRegistrarState` call per register is the only way to learn it.
 * It starts closed and is corrected by `applyRegistrarState`.
 */
export const toRegisters = (
  response: IObjectsResponse | null,
): IRegisterWithOwner[] =>
  (response?.TaxObjects ?? []).flatMap(taxObject =>
    (taxObject.TransactionsRegistrars ?? []).map(registrar => ({
      fiscalNumber: String(registrar.NumFiscal),
      name: registrar.Name,
      address: taxObject.Address,
      state: registrar.Closed
        ? CashRegisterStateEnum.Closed
        : CashRegisterStateEnum.Active,
      shiftState: ShiftStateEnum.Closed,
      taxNumber: taxObject.Tin,
      organisationName: taxObject.OrgName,
      businessUnitName: taxObject.Name,
      taxObjectId: taxObject.TaxObjGuid,
      localNumber: registrar.NumLocal,
    })),
  );

/** `ShiftState` is 1 while a shift is open — see ai/docs/prro-api.md. */
export const applyRegistrarState = ({
  register,
  state,
}: {
  register: IRegisterWithOwner;
  state: IRegistrarStateResponse | null;
}): IRegisterWithOwner => {
  if (!state) return register;

  return {
    ...register,
    shiftState:
      state.ShiftState === 1 ? ShiftStateEnum.Opened : ShiftStateEnum.Closed,
    name: register.name || state.TaxObject?.Name || "",
    address: register.address || state.TaxObject?.Address || "",
  };
};
